import WebApi from "@/views/loyalty/shared/modules/web_api"

export class ConditionEndpoint {
    constructor () {
        this.url = `${process.env.VUE_APP_LOYALTY_URL}api/condition/`
        this.url2 = `${process.env.VUE_APP_LOYALTY_URL}api/conditions/`
        this.webApi = new WebApi()
    }

    async read_condition (conditionId) {
        const condition = await this.webApi.get(`${this.url}${conditionId}`)
        if (!condition.status_code) {
            return condition
        } else {
            console.error(`Ошибка с кодом: ${condition.status_code}`)
        }
    }

    async read_conditions (ruleId) {
        const conditions = await this.webApi.get(`${this.url2}${ruleId}`)
        if (!conditions.status_code) {
            return conditions
        } else {
            console.error(`Ошибка с кодом: ${conditions.status_code}`)
        }
    }

    async create_condition (conditionCreate) {
        const conditionCreated = await this.webApi.post(`${this.url}`, conditionCreate)
        return conditionCreated
    }

    async update_condition (conditionId, conditionUpdate) {
        const conditionUpdated = await this.webApi.patch(`${this.url}${conditionId}`, conditionUpdate)
        return conditionUpdated
    }

    async delete_condition (conditionId) {
        return this.webApi.delete(`${this.url}${conditionId}`)
    }
}
